import { Component, OnInit, Input } from '@angular/core';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { MatTabChangeEvent } from '@angular/material';
import { Router } from '@angular/router';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.css']
})
export class DocumentComponent implements OnInit {
  Uploaded;
  @Input() documenttab = 0;
  public patientId: number = CommonComponents.patientId;
  public patientName: string = CommonComponents.patientName;
  constructor(private router: Router) { }

  ngOnInit() {
  }

  onLinkClick(event: MatTabChangeEvent) {
    event.tab.isActive = true;
    this.router.navigateByUrl('/' + event.tab.textLabel);
  }

}
